<!--
 * @Description: 使用频率、月活跃天数
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 14:23:20
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-23 13:43:52
 -->
<template>
  <div class="useFrequency">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">日均使用频率/月活跃天数</span>
    </div>
    <div class="useFrequencyCharts" ref="useFrequencyCharts"></div>
    <div class="legendDescription">
      <div class="legendItem" v-for="(item, index) in legendDescription" :key="index">
        <span class="color" :style="{'background':item.color}"></span>
        <span class="label" :style="{'color':item.color}">{{item.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'useFrequency',
  components: {
  },
  data () {
    return {
      legendDescription: [
        {
          label: '正常',
          color: '#00ffee',
        },
        {
          label: '一般',
          color: '#ff7123',
        },
        {
          label: '闲置',
          color: '#da0000',
        },
      ],
      charts: '',
      xAxis: [],
      useFrequencyYAxis: [],
      activeDaysYAxis: [],
    }
  },
  methods: {
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.useFrequencyCharts)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          textStyle: {
            color: '#fff',
          },
          data: ['使用频率', '活跃天数'],
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
            data: this.xAxis,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '使用频率（次）',
            position: 'left',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
          {
            type: 'value',
            name: '活跃天数（天）',
            position: 'right',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
        ],
        series: [
          {
            name: '使用频率',
            type: 'bar',
            yAxisIndex: 0,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(3,247,247,0.9)',
              }, {
                offset: 0.3,
                color: 'rgba(3,247,247,0.9)',
              }, {
                offset: 1,
                color: 'rgba(20,51,56,0.9)',
              }]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: 7,
            data: this.useFrequencyYAxis,
          },
          {
            name: '活跃天数',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(0,174,255,0.9)',
              }, {
                offset: 0.3,
                color: 'rgba(0,174,255,0.9)',
              }, {
                offset: 1,
                color: 'rgba(21,48,60,0.9)',
              }]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: 7,
            data: this.activeDaysYAxis,
          },
        ],
      }
      this.charts.setOption(option)
    },
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/common/useRateActiveDays', {
        productCode: 'lcgl',
      })
        .then(res => {
          if (res.code === 0) {
            let xAxis = []
            let useFrequencyYAxis = []
            let activeDaysYAxis = []
            res.data.map(item => {
              xAxis.push({
                value: item.shortName,
                textStyle: {
                  color: this.activeXAxisColor(item.usage),
                  fontWeight: 'bold',
                },
              })
              useFrequencyYAxis.push(item.loginNum)
              activeDaysYAxis.push(item.days)
            })
            this.xAxis = xAxis
            this.useFrequencyYAxis = useFrequencyYAxis
            this.activeDaysYAxis = activeDaysYAxis
            this.initCharts()
            window.onresize = () => {
              this.charts.resize()
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   X轴动态颜色
     * @return {undefied}             无返回值
     */
    activeXAxisColor (value) {
      if (value < 20) {
        return '#da0000'
      } else if (value >= 20 && value < 60) {
        return '#ff7123'
      } else if (value >= 60) {
        return '#00ffee'
      }
    },
  },
  mounted () {
    this.getData()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .useFrequency {
    width: 100%;
    height: 100%;
    position: relative;
    .titleHeader {
      width: 100%;
      height: 4vh;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      >img {
        height: 100%;
        margin-right: 20px;
      }
      .titleName {
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5vh;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #05dbe3;
      }
      /deep/.useFrequencySelecter {
        width: 15%;
        height: 100%;
        margin-left: 38%;
        .el-input {
          height: 100%;
          .el-input__inner {
            height: 90%;
            background: none;
            border: 1px solid#00ffee;
            border-radius: 2px;
            color: #00ffee;
          }
          .el-input__suffix {
            .el-input__suffix-inner {
              .el-input__icon {
                color: #00ffee;
              }
            }
          }
        }
      }
    }
    .useFrequencyCharts {
      width: 100%;
      height: 90%;
    }
    .legendDescription {
      width: 100%;
      height: 5%;
      display: flex;
      justify-content: space-around;
      position: absolute;
      bottom: 7%;
      left: 0;
      .legendItem {
        .color {
          display: inline-block;
          width: 10px;
          height: 10px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .label {
          font-size: 1vh;
          vertical-align: middle;
        }
      }
    }
  }
</style>
